// skipcq: JS-W1028
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

/**
 * @typedef {object} BrewhouseBreadcrumbSegment
 * @property {string} label
 * @property {string} [to] — omit for current page (plain text)
 */

/**
 * Brewhouse portal breadcrumb trail.
 *
 * @param {object} props
 * @param {BrewhouseBreadcrumbSegment[]} props.segments
 */
function BrewhouseBreadcrumbs({ segments, sx = {} }) {
  if (!Array.isArray(segments) || segments.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs aria-label="Brewhouse navigation" sx={{ mb: 1, ...sx }}>
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1;
        const key = `${segment.label}-${index}`;

        if (isLast || !segment.to) {
          return (
            <Typography
              key={key}
              variant="body2"
              color="text.primary"
              sx={{
                maxWidth: 240,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {segment.label}
            </Typography>
          );
        }

        return (
          <Link
            key={key}
            component={RouterLink}
            to={segment.to}
            variant="body2"
            underline="hover"
            color="inherit"
          >
            {segment.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

BrewhouseBreadcrumbs.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string,
    }),
  ).isRequired,
  sx: PropTypes.object,
};

export default BrewhouseBreadcrumbs;
